import commonMixin from '@/mixins/commonMixin'
import errorMixin from '@/mixins/errorMixin'
import blobService from '@/services/blobService'

export default {
  mixins: [
    commonMixin,
    errorMixin
  ],
  data () {
    return {
      blobMixin: {
        blobStatus: {
          unchanged: 0,
          created: 1,
          updated: 2,
          deleted: 3
        }
      }
    }
  },
  mounted () {
    blobService.Init(this)
  },
  methods: {
    async BlobMixin_Download (blob) {
      if (blob) {
        if (blob.blobDataString) {
          this.BlobMixin_DownloadAction(blob.bestandsnaam, blob.blobDataString)
        } else {
          await this.BlobMixin_DownloadExisting(blob)
        }
      }
    },
    BlobMixin_DownloadAction (filename, data = null, filestream = null) {
      if (filestream) {
        data = window.URL.createObjectURL(filestream)
      }

      const docUrl = document.createElement('a')
      docUrl.href = data
      docUrl.download = filename.replaceAll('"', '')
      docUrl.click()
    },
    BlobMixin_DownloadApiGeneratedFile (response, isBase64 = false) {
      this.BlobMixin_DownloadAction(this.BlobMixin_GetFileNameFromHeader(response.headers['content-disposition']), isBase64 ? response.data : null, isBase64 ? null : response.data)
    },
    async BlobMixin_DownloadExisting (blob) {
      if (blob) {
        const resp = await blobService.Download(blob.idBlob)

        if (resp && (resp.data || resp.data !== '')) {
          this.BlobMixin_DownloadAction(blob.bestandsnaam, null, resp.data)
        }
      }
    },
    async BlobMixin_DownloadZip (ids) {
      if (ids) {
        const resp = await blobService.DownloadZip(ids)

        if (resp && (resp.data || resp.data !== '')) {
          this.BlobMixin_DownloadApiGeneratedFile(resp)
        }
      }
    },
    async BlobMixin_OpenExisting (blob) {
      if (blob) {
        const resp = await blobService.GetBase64(blob.idBlob)

        if (resp && (resp.data || resp.data !== '')) {
          this.$store.state.blobDialog.source = resp.data.blobDataString
          this.$store.state.blobDialog.show = true
        }
      }
    },
    BlobMixin_GetFileNameFromHeader (contentDisposition) {
      const property = 'filename='
      const valueIndex = contentDisposition.indexOf(property) + property.length
      const endIndex = contentDisposition.indexOf(';', valueIndex)
      const name = contentDisposition.substr(valueIndex, endIndex - valueIndex)

      return name
    },
    BlobMixin_GetFileNameShortened (blob) {
      if (blob) {
        const name = blob.bestandsnaam
        const firstPart = 10
        const secondPart = 10
        const maxLength = firstPart + secondPart + 1

        if (name && name.length > maxLength) {
          return `${blob.bestandsnaam.substr(0, firstPart)}…${blob.bestandsnaam.substr(name.length - secondPart)}`
        } else {
          return blob.bestandsnaam
        }
      } else {
        return null
      }
    },
    BlobMixin_GetFileSize (blob, unit = '', showUnit = true, showZero = true) {
      if (blob && blob.blobDataString) {
        let size = Buffer.from(blob.blobDataString, 'base64').length
        let exponent = 0

        if (showZero || size) {
          switch (unit) {
            case 'KB':
              exponent = 1
              break
            case 'MB':
              exponent = 2
              break
            case 'GB':
              exponent = 3
              break
          }

          size /= Math.pow(1024, exponent)

          return showUnit ? `${this.FormatMixin_FormatDecimal(size)}${unit}` : size
        } else {
          return null
        }
      } else {
        return null
      }
    },
    BlobMixin_HandleFileUpload (blob, event, maxFileSize) {
      const fileList = event.target.files || event.dataTransfer.files

      if (fileList.length > 0) {
        const files = []

        for (const property in fileList) {
          const value = fileList[property]
          if (typeof (value) === 'object') {
            files.push(value)
          }
        }

        if (maxFileSize && files.find(file => file.size > maxFileSize * Math.pow(1024, 2))) {
          alert(this.textMixin.messages.maxFileSize.replaceAll('@@maxFileSize', maxFileSize))
        } else {
          this.BlobMixin_ReadFileUpload(blob, files[0], event.srcElement.value.replace(/^.*?([^\\/]*)$/, '$1'))
        }
      }
    },
    BlobMixin_HandleVFileUpload (blobProperty, file) {
      if (file == null) {
        blobProperty = null
      } else {
        this.BlobMixin_ReadFileUpload(blobProperty, file, file.name)
      }
    },
    BlobMixin_ReadFileUpload (blob, file, filename) {
      this.CommonMixin_Load(this.$options.name, true)
      const reader = new FileReader()

      reader.onload = (e) => {
        blob.blobDataString = e.target.result
        blob.bestandsnaam = filename
      }

      reader.readAsDataURL(file)
      this.CommonMixin_Load(this.$options.name, false)
    }
  }
}
